<template>
  <div class="feedback">
    <modal
      ref="irregularLaboratoryModal"
      template="question"
      title="Aviso"
      ref-name="irregularLaboratoryModal"
      second-button-text="Ok"
      :hide-first-button="true"
      class="feedback"
      @second-cta="showIrregularModal(false)"
    >
      <p>
        Identificamos problemas de faturamento que estão restringindo
        <br />
        o envio de suas amostras.
      </p>

      <p>
        Por favor, entre em contato com nosso suporte pelo telefone
        <br />
        <span class="bold">0800 643 8100</span>
        ou pelo e-mail
        <a
          class="link"
          href="mailto:cobranca@dasa.movidesk.com"
          title="cobranca@dasa.movidesk.com"
        >
          cobranca@dasa.movidesk.com
        </a>
        <br />
        para mais informações.
      </p>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  watch: {
    isIrregularVisible() {
      if (this.isIrregularVisible) {
        this.$refs.irregularLaboratoryModal.open()
      } else {
        this.$refs.irregularLaboratoryModal.close()
      }
    },
  },
  computed: {
    ...mapGetters(['isIrregularVisible']),
  },
  methods: {
    ...mapActions(['showIrregularModal']),
  },
}
</script>

<style lang="scss">
.feedback {
  .bold {
    font-weight: bold;
    letter-spacing: normal;
  }
  .link {
    color: #7f1a54 !important;
    text-decoration: none !important;
    border-bottom: 1px solid #7f1a54 !important;

    &:not(.md-button):not(.md-bottom-bar-item):hover {
      color: #944b75 !important;
      text-decoration: none !important;
      border-bottom: 1px solid #944b75 !important;
    }
  }
}
</style>
